import React, { useState, useEffect } from "react";
import "./AddingConcert.css";
import { getConcertById, updateConcert } from "./ConcertApi";
import { useNavigate, useParams } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const EditConcertModal = () => {
  const [concertName, setConcertName] = useState("");
  const [concertTime, setConcertTime] = useState("");
  const [concertDate, setConcertDate] = useState("");
  const [hostName, setHostName] = useState("");

  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const { id } = useParams();
  const numericId = Number(id);
  useEffect(() => {
    console.log("Parametr ID:", id);
    if (isNaN(numericId)) {
      alert("Nieprawidłowy ID");
      navigate(-1);
      return;
    }
  
    getConcertById(axiosPrivate, numericId, (concert) => {
      if (concert) {
        console.log("Dane koncertu:", concert);
        setConcertName(concert.miejsceKoncertu || "");  
        if (concert.dataKoncertu) {
          const [date, time] = concert.dataKoncertu.split(" ");  
          console.log("Rozdzielona data:", date, "Godzina:", time);
          setConcertDate(date || "");
          setConcertTime(time || "");
        }
        setHostName(concert.Prowadzacy || ""); 
      } else {
        alert("Nie znaleziono koncertu do edycji.");
        navigate(-1);
      }
    });
  }, [id, axiosPrivate, navigate]);
  
  
  

  const handleCloseModal = () => {
    navigate(-1);
  };

  const isValidDateTime = (date:string, time:string) => {
    const datePattern = /^\d{4}-\d{2}-\d{2}$/;
    const timePattern = /^\d{2}:\d{2}$/;
    return datePattern.test(date) && timePattern.test(time);
  };

  const handleUpdateConcert = () => {
    if (!concertName || !concertTime || !concertDate || !hostName) {
      alert("Wszystkie pola są wymagane!");
      return;
    }

    if (!isValidDateTime(concertDate, concertTime)) {
      alert("Podaj poprawny format daty (YYYY-MM-DD) i godziny (HH:mm)!");
      return;
    }

    const dateTime = `${concertDate} ${concertTime}`;

    const updatedConcertData = {
      place: concertName,
      date: dateTime,
      host: hostName,
    };

    updateConcert(
      axiosPrivate,
      numericId,
      updatedConcertData,
      (response) => {
        console.log("Zaktualizowano koncert:", response);
        alert("Koncert został zaktualizowany!");
        navigate(-1);
      },
      (error) => {
        console.error("Błąd podczas aktualizacji koncertu:", error);
        alert("Wystąpił błąd podczas aktualizacji koncertu.");
      }
    );
  };

  return (
    <div className="custom-modal-addconcert">
      <div className="custom-modal-content-addconcert">
        <button onClick={handleCloseModal} className="close-button">
          ✖
        </button>
        <h3 className="modal-title">Edytuj koncert</h3>
        <div className="form-container-addconcert">
          <div className="row-addconcert">
            <div className="form-group-addconcert">
              <label>Nazwa koncertu</label>
              <input
                type="text"
                placeholder="Wpisz tutaj"
                value={concertName}
                onChange={(e) => setConcertName(e.target.value)}
                className="modal-input-addconcert"
              />
            </div>
            <div className="form-group-addconcert">
              <label>Godzina rozpoczęcia</label>
              <input
                type="time"
                value={concertTime}
                onChange={(e) => setConcertTime(e.target.value)}
                className="modal-input-addconcert"
              />
            </div>
            <div className="form-group-addconcert">
              <label>Data</label>
              <input
                type="date"
                value={concertDate}
                onChange={(e) => setConcertDate(e.target.value)}
                className="modal-input-addconcert"
              />
            </div>
          </div>
          <div className="row-addconcert">
            <div className="form-group-addconcert">
              <label>Prowadzący</label>
              <input
                type="text"
                placeholder="Wpisz tutaj"
                value={hostName}
                onChange={(e) => setHostName(e.target.value)}
                className="modal-input-addconcert modal-input-hostname"
              />
            </div>
          </div>
        </div>
        <div className="modal-event-buttons-addconcert">
          <button onClick={handleUpdateConcert} className="custom-modal-button-addconcert">
            Zaktualizuj
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditConcertModal;
